import { Component } from '@angular/core';

import { Router, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../../shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { LOGIN_ROUTE } from '../../../shared/constants/constants';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-password',
  imports: [RouterModule, ReactiveFormsModule, FormsModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  protected email: string = '';
  genericErrorTranslated = '';
  successToastrMessage = '';

  constructor(
    private authService: AuthService,
    private toastr: ToastrService,
    private router: Router,
    private translateService: TranslateService
  ) {
    this.genericErrorTranslated = this.translateService.instant('errors.generic_error');
    this.successToastrMessage = this.translateService.instant('success');
  }

  forgotPassword() {
    this.authService.forgotPassword(this.email).subscribe({
      next: (data: any) => {
        this.toastr.success(
          data?.message ?? this.translateService.instant('forgot-password.success'),
          this.successToastrMessage
        );
        setTimeout(() => {
          this.router.navigate([LOGIN_ROUTE]);
        }, 3000);
      },
      error: (error) => {
        this.toastr.error(this.genericErrorTranslated, error.message);
      },
      complete: () => {}
    });
  }
}
